//@ts-ignore
import $i18n from '@/i18n';
import React from 'react';
import DarkToolTip from '../../../../../../components/DarkToolTip';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

const iconCellRender = (v, record, addSet, removeSet) => v === 'CONTROLLED' || addSet.has(record.jsapiName) ? <CheckCircleOutlined style={{ fontSize: 14, color: '#29A64E' }} /> : <CloseCircleOutlined style={{ fontSize: 14, color: "#D4D6DB" }} />

const tipRenderCell = (v, i, record) => <DarkToolTip placement="topLeft" arrow={{ pointAtCenter: true }} triggerContent={v} content={v} />

export const tableColumons = (addSet, removeSet) => [
  {
    title: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.jsapiName", dm: '名称' }),
    dataIndex: 'jsapiName',
    width: 100,
    cell: tipRenderCell,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.functionDesc', dm: '描述' }),
    dataIndex: 'functionDesc',
    cell: tipRenderCell,
    width: 150,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.channelName', dm: '渠道' }),
    dataIndex: 'channelName',
    cell: tipRenderCell,
    width: 97,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.supportSystem', dm: '支持的系统' }),
    dataIndex: 'supportSystem',
    width: 160,
    cell: (v) => v?.join(' / '),
  },
  {
    title: $i18n.get({ id: 'aopf.pages.channel.jsApiAuth.jsapiTable.column.controlStatus', dm: '是否加入了授权列表' }),
    dataIndex: 'controlStatus',
    width: 152,
    cell: (v, i, record) => iconCellRender(v, record, addSet, removeSet),
  },
];
